const initCompanyConsolidationSettingsModal = ($dom) => {
  $dom
    .find("[data-behaviour='company-consolidations-modal']")
    .each((index, el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault()

        const modalParams = {
          companyConsolidation: JSON.parse(el.dataset.companyConsolidation),
          subsidiaryCompany: JSON.parse(el.dataset.subsidiaryCompany),
          parentCompany: JSON.parse(el.dataset.parentCompany),
          consolidationCompany: JSON.parse(
            el.dataset.consolidationCompany || '{}'
          ),
          subconsolidations: JSON.parse(el.dataset.subconsolidations || '[]'),
          companyLink: el.dataset.companyLink || '#',
        }

        window.modalCitizen.openModal(
          'company-consolidation-settings-modal',
          modalParams
        )
      })
    })
}

$(document).on('initCompanyConsolidationSettingsModal', function (_event, el) {
  const $el = $(el)
  initCompanyConsolidationSettingsModal($el)
})

onDomLoad(function ($dom) {
  initCompanyConsolidationSettingsModal($dom)
})
